import { useState, useEffect } from 'react';
import { usePortfolio } from '../../context/PortfolioContext';
import TickerSearchInput from '../TickerSearchInput';

function DividendModal({ isOpen, onClose, dividend = null }) {
  const { createDividend, updateDividend } = usePortfolio();
  const [formData, setFormData] = useState({
    date: new Date().toISOString().split('T')[0],
    ticker: '',
    amount_gbp: '',
  });

  useEffect(() => {
    if (dividend) {
      setFormData({
        date: dividend.date || new Date().toISOString().split('T')[0],
        ticker: dividend.ticker || '',
        amount_gbp: dividend.amount_gbp || '',
      });
    } else {
      // Reset form for new dividend
      setFormData({
        date: new Date().toISOString().split('T')[0],
        ticker: '',
        amount_gbp: '',
      });
    }
  }, [dividend, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      ...formData,
      amount_gbp: Number(formData.amount_gbp),
    };

    const success = dividend 
      ? await updateDividend(dividend.id, data)
      : await createDividend(data);

    if (success) {
      onClose();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleTickerChange = (upperValue) => {
    setFormData(prev => ({ ...prev, ticker: upperValue }));
  };

  const selectSuggestion = (suggestion) => {
    setFormData(prev => ({
      ...prev,
      ticker: suggestion.symbol || suggestion.internal_ticker,
    }));
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <span className="modal-title">{dividend ? 'Edit Dividend' : 'New Dividend'}</span>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-grid">
              <div className="form-group">
                <label>Date</label>
                <input 
                  type="date" 
                  name="date" 
                  value={formData.date} 
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="form-group">
                <label>Ticker</label>
                <TickerSearchInput
                  value={formData.ticker}
                  onChange={handleTickerChange}
                  onSelectSuggestion={selectSuggestion}
                  required
                />
              </div>
            </div>
            
            <div className="form-group">
              <label>Amount (GBP)</label>
              <input 
                type="number" 
                name="amount_gbp" 
                value={formData.amount_gbp} 
                onChange={handleChange}
                step="0.01"
                placeholder="0.00"
                required 
              />
            </div>
          </div>
          
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              {dividend ? 'Update' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default DividendModal;
